import React from "react";
import { inject, observer } from "mobx-react";
import gameActionOptions from "../constants/gameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class RookieGameActionDropDownContainer extends React.Component {
  render() {
    const { RookieGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={gameActionOptions}
        transitionToCreateIncident={
          RookieGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={RookieGameActionStore.clearClippyCache}
        clearStatsApiCache={RookieGameActionStore.clearStatsApiCache}
        resendGame={RookieGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(observer(RookieGameActionDropDownContainer));
